


































































import { defineComponent, ref, watch } from '@vue/composition-api';
import { useBadge } from '@/bundles/Badge/composables/useBadge';
import { IBadge } from '@/bundles/Badge/interfaces';
import { Nullable, VForm } from '@/bundles/App/type';
import { IUpdateBadgeInfoDto } from '@/bundles/Badge/dto';

export default defineComponent({
  name: 'BadgeEditForm',

  emits: ['badge:refresh', 'icon:update', 'icon:reset'],

  props: {
    visibility: Boolean,
    badgeEntry: {
      type: Object,
      required: true,
    }
  },

  setup: function (props, { emit }) {
    const badgeForm = ref(null);
    const { badge, editLoading, resetBadge, edit } = useBadge();
    const file = ref<Nullable<File>>();
    const fileReader = ref<Nullable<FileReader>>(null);

    const pickIcon = ref(false);
    watch(() => pickIcon.value, (value) => {
      if(!value) {
        fileReader.value = null;
        emit('icon:reset');
        return;
      }

      fileReader.value = new FileReader();

      fileReader.value.onload = (event) => {
        emit('icon:update', { url: event?.target?.result });
      }
    })

    watch(() => file.value, (value) => {
      if (value) {
        fileReader.value?.readAsDataURL(value);
      }
    })

    watch(() => props.badgeEntry, function () {
      badge.value = { ...props.badgeEntry as IBadge };
    }, { deep: true, immediate: true });

    function resetValidation () {
      (badgeForm.value as unknown as VForm).resetValidation();
    }

    watch(() => props.visibility, function (value: boolean) {
      if (value) {
        return;
      }
      resetBadge();
      file.value = null;
      pickIcon.value = false;
      resetValidation();
    });

    async function submitEventHandler () {
      if (!(badgeForm.value as unknown as VForm).validate()) {
        return;
      }
      try {
        const payload: IUpdateBadgeInfoDto = {
          name: badge.value.name,
          description: badge.value.description,
        };
        if (file.value) {
          payload.file = file.value;
        }
        await edit(badge.value.id, payload);
        emit('badge:refresh', badge.value);
      } catch (error) {
        console.error(error);
      } finally {
        editLoading.value = false;
      }
    }

    return {
      badgeForm,
      badge,
      file,
      editLoading,
      pickIcon,
      submitEventHandler,
    };
  },
});
